import { createStitches, defaultThemeMap } from '@stitches/react';
import { baseTokens } from '@betrybe/ada-react';

export const { styled, css } = createStitches({
  theme: baseTokens,
  themeMap: {
    ...defaultThemeMap,
    font: 'typographies',
  },
  media: {
    sm: '(min-width: 640px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1024px)',
    xl: '(min-width: 1280px)',
  },
});
